import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getSiteList, unloadSiteList } from "../../redux/actions/asset.actions";
import SiteList from "../../components/SiteList";
import Nav from "../../components/Nav";
import Header from "../../components/Header";
import { Translation } from "react-i18next";
import i18n from "../../languages/lang.js";

export default () => {
  const asset = useSelector(state => state.asset);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getSiteList());
    return () => dispatch(unloadSiteList());
  }, []);

  if (!asset.sites) {
    return (
      <Translation>
        {t => (
          <div id="main">
            <Nav selected={"sites"} />
            <div id="content">
              <Header />
              <div id="loading">{t("system.loading")}</div>
            </div>
          </div>
        )}
      </Translation>
    );
  }

  return (
    <Translation>
      {t => (
        <div id="main">
          <Nav selected={"sites"} />
          <div id="content">
            <Header />
            <div className="content-wrap">
              <div className="box-header">
                <Link className="header-button" to="/sites/add">
                  {" "}
                  {t("site.create_button")}{" "}
                </Link>
                <h2>{t("site.list_title")}</h2>
              </div>
              <SiteList data={asset.sites} />
              <hr className="break" />
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
};
